<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { HTMLAttributes } from 'svelte/elements';

  let {
    as = 'div',
    class: className = '',
    children,
    ...rest
  }: HTMLAttributes<HTMLElement> & {
    as?: 'div' | 'section' | 'form' | 'main';
    class?: string;
    autocomplete?: string;
    children?: Snippet;
  } = $props();
</script>

<svelte:element this={as} {...rest} class={`surface card${className ? ` ${className}` : ''}`}>
  {@render children?.()}
</svelte:element>
